/* One way to name a home everywhere: "2500 Longview Street 210" — street, then unit.
   Records from the API carry `home` (server-built); anything older composes it from address + unit. */
export const homeLabel = (x, { unit = "unit", address = "address" } = {}) => {
  if (!x) return "";
  if (x.home) return x.home;
  const street = String(x[address] || "").split(",")[0].trim();
  return [street, String(x[unit] || "").trim()].filter(Boolean).join(" ");
};

export const reporterHome = (ev) => homeLabel(ev, { unit: "reporter_unit", address: "reporter_address" }) || homeLabel(ev);
